function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { warning } from '../utils';
export function getColKey(col, colIdx) {
  return col.key || "$$_id".concat(colIdx);
}
export function getRowKey(rowKey, record, rowIdx) {
  var key = typeof rowKey === 'function' ? rowKey(record, rowIdx) : record[rowKey];
  warning(key !== undefined, 'Each record in dataSource of table should have a unique `key` prop, or set `rowKey` to an unique primary key');
  return key === undefined ? "$$_id".concat(rowIdx) : String(key);
}
export function isFunction(fn) {
  return typeof fn === 'function';
}
export function flatRows() {
  var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var childColName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'children';
  var deep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return rows.reduce(function (r, v) {
    var nr = r;
    nr.push(deep ? _objectSpread({}, v) : v);
    var child = v[childColName];

    if (Array.isArray(child) && child.length > 0) {
      nr.push.apply(nr, _toConsumableArray(flatRows(v[childColName], childColName, deep)));
    }

    return nr;
  }, []);
}

function recursiveRows() {
  var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var cb = arguments.length > 1 ? arguments[1] : undefined;
  var childColName = arguments.length > 2 ? arguments[2] : undefined;
  var deep = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var ret = [];

  for (var i = 0, l = rows.length; i < l; i += 1) {
    var row = rows[i];
    var r = deep ? _objectSpread({}, row) : row;
    ret.push(isFunction(cb) ? cb(r) : r);
    var child = row[childColName];

    if (Array.isArray(child) && child.length > 0) {
      r[childColName] = recursiveRows(child, cb, childColName, deep);
    }
  }

  return ret;
}

export function normalizeRows() {
  var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var childColName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'children';
  var deep = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  return recursiveRows(rows, cb, childColName, deep);
}
export function normalizeCols() {
  var cols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var childColName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'children';
  var deep = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  return recursiveRows(cols, cb, childColName, deep);
}
export function recursiveSort() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var sortFn = arguments.length > 1 ? arguments[1] : undefined;
  var childColName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'children';
  return data.sort(sortFn).map(function (v) {
    var nv = v;
    var child = nv[childColName];

    if (Array.isArray(child) && child.length > 0) {
      nv[childColName] = recursiveSort(child, sortFn, childColName);
    }

    return nv;
  });
}